import { createActionCreator } from '../utils/helpers';

import {
  lenderProductsStatus,
  lenderToggleStatusBySection,
  lenderProduct,
  updateLenderProduct,
  lenderProductOffer,
} from './types';

export const requestLenderProductsStatus = createActionCreator(
  lenderProductsStatus.request,
  'promise',
);
export const requestLenderProductsStatusSuccess = createActionCreator(
  lenderProductsStatus.success,
  'response',
);
export const requestLenderProductsStatusFailure = createActionCreator(
  lenderProductsStatus.failure,
  'error',
);

export const requestLenderToggleStatusBySection = createActionCreator(
  lenderToggleStatusBySection.request,
  'section',
  'checked',
);

export const requestLenderProduct = createActionCreator(lenderProduct.request, 'section');
export const requestLenderProductSuccess = createActionCreator(
  lenderProduct.success,
  'section',
  'response',
);
export const requestLenderProductFailure = createActionCreator(
  lenderProduct.failure,
  'section',
  'error',
);

export const requestUpdateLenderProduct = createActionCreator(
  updateLenderProduct.request,
  'data',
  'section',
  'formTab',
);

export const requestLenderProductOffer = createActionCreator(
  lenderProductOffer.request,
  'fundingMatchId',
  'fundingSearchId',
);
export const requestLenderProductOfferSuccess = createActionCreator(
  lenderProductOffer.success,
  'response',
);
export const requestLenderProductOfferFailure = createActionCreator(
  lenderProductOffer.failure,
  'error',
);
